import { render, staticRenderFns } from "./PostUser.vue?vue&type=template&id=9cbb43c4"
import script from "./PostUser.vue?vue&type=script&lang=js"
export * from "./PostUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports